import { useState } from 'react';
import { WinePackageWidgetModel } from '../../../models/WinePackageWidgetModel';

interface useWineContentInfo {
  winePackage: WinePackageWidgetModel;
}

/**
 * The useWineContentInfo hook returns the content of a wine package.
 * @param winePackage - The object containing information about the wine package.
 * @returns The useWineContentInfo hook returns the content of a wine package.
 */

export const useWineContentInfo = ({ winePackage }: useWineContentInfo) => {
  const [tooltipContent, setTooltipContent] = useState<string>('');

  // get the packages content on hover the tooltip
  const handleIconHover = () => {
    if (!winePackage?.content) return;

    const contentMap: { [title: string]: { count: number; productYear: number | null } } = {};

    winePackage.content.forEach((packageElement) => {
      const title = packageElement.title;
      const productYear = packageElement.productYear;

      if (!contentMap[title]) {
        contentMap[title] = { count: 1, productYear: productYear };
      } else {
        contentMap[title].count++;
        if (contentMap[title].productYear !== productYear) {
          contentMap[title].productYear = null;
        }
      }
    });

    const content = Object.entries(contentMap)
      .map(([title, { count, productYear }]) => {
        return `${title} ${productYear}${count > 1 ? ` x${count}` : ''}`;
      })
      .join('<br/>');

    setTooltipContent(content || '');
  };

  // reset the content when stop hovering the tooltip
  const handleIconLeave = () => {
    setTooltipContent('');
  };

  return { tooltipContent, handleIconHover, handleIconLeave };
};
